import { useStores } from '../../../../../app/root/domain/stores/useStores';

export function useTokenizedCardsStore() {
	const { tokenizedCardsStore } = useStores();

	return tokenizedCardsStore;
}
